import axios from 'axios';
import AuthService from 'services/AuthService';



const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers['X-auth-token'] = `${token}`;
  }
  return config;
},
(error) => {
  return Promise.reject(error);  
}
);

instance.interceptors.response.use(
  (response) => {
    return response; 
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized access. Redirecting to login...');
      
      AuthService.logout();      
      
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);


export default instance;
